import { render, staticRenderFns } from "./PromotionRowCTA.vue?vue&type=template&id=aca886ec&scoped=true"
import script from "./PromotionRowCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionRowCTA.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotionRowCTA.vue?vue&type=style&index=0&id=aca886ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca886ec",
  null
  
)

export default component.exports